/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:081e8823-760a-4209-9eeb-bf8cb868c70d",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_3yqxgdSpC",
    "aws_user_pools_web_client_id": "3c6d80b8ooapmsicet0schj3n4",
    "oauth": {
        "domain": "searchapplicationfbb2afeb-fbb2afeb-prod.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://dev.d1rcjjv6tdpjni.amplifyapp.com/",
        "redirectSignOut": "http://localhost:3000/,https://dev.d1rcjjv6tdpjni.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};


export default awsmobile;
